export default "__VITE_ASSET__DTRJJT7S__"